import { render, staticRenderFns } from "./EditAuthorization.vue?vue&type=template&id=09ccc436&"
import script from "./EditAuthorization.vue?vue&type=script&lang=js&"
export * from "./EditAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports